import React, { FC, useEffect, useState } from "react";
import cn from "clsx";
import { useTranslation } from "react-i18next";
import {
  TabbyInfoModal,
  TabbyInfoModalType
} from "../../../components/tabby/tabbyInfoModal";
import { useCurrency, useIsRTL, useLanguage } from "../../../hooks";
import HtmlParser from "../../../components/html-parser";
import PdpAnalyticsEvent from "../../../services/analytics/main/pdp";
import InfoIconGrey from "../../../images/info-icon-grey.svg";
import "./style.scss";
import { TamaraInfoModalType } from "@/components/tamara/tamaraInfoModal";

type PayLaterOptionItemProps = {
  paymentService?: any;
  paymentSystemIcon: string;
  price: number;
  normalPrice: string | number;
  paymentMode: string;
  payIconClassName?: string;
  ModalComponent: React.FC<TamaraInfoModalType | TabbyInfoModalType>;
  optionMessages: string[];
};

const PayLaterOptionItem: FC<PayLaterOptionItemProps> = ({
  paymentService,
  paymentSystemIcon,
  price,
  normalPrice,
  paymentMode,
  payIconClassName,
  ModalComponent = TabbyInfoModal,
  optionMessages
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const languageSlug = useLanguage();
  const isRTL = useIsRTL();
  const currencyCode = useCurrency();
  const { t } = useTranslation("productDetails");
  useEffect(() => {
    if (paymentService) {
      paymentService.loadSdk();
    }
  }, []);

  useEffect(() => {
    if (paymentService && paymentService.isSdkLoaded) {
      paymentService.init({});
    }
  }, []);

  const handleInfoIconClick = () => {
    setModalOpen(true);
    PdpAnalyticsEvent.paymentMethodInfo({
      method: paymentMode
    });
  };

  return (
    <div
      className={cn("price-snippet", {
        arabic: isRTL
      })}
    >
      <div className="description">
        <>
          {optionMessages.map((message: string, index: number) => {
            return <HtmlParser html={message} key={index} />;
          })}
        </>
        <span className="learn_more" onClick={handleInfoIconClick}>
          {t("learnMore")}
        </span>
      </div>

      <div
        className={cn("pay-icon", paymentMode.toLowerCase(), payIconClassName)}
      >
        <div className="position-relative">
          <img
            src={paymentSystemIcon}
            alt="Payment System Icon"
            className="svg-icon payment-system-icon"
          />
          <div className="info-icon d-none-resp" onClick={handleInfoIconClick}>
            <img src={InfoIconGrey} alt="info" />
          </div>
        </div>
        <div
          /*
           * A blank element needed to detect a click event to open Tabby Promo modal.
           * It is a quick fix, because of adding data-tabby-info attribute to HTML
           * elements that have child elements has no effect
           */
          className="touch-detector"
          data-tabby-info="installments"
          data-tabby-language={languageSlug}
        />
      </div>

      {modalOpen && (
        <ModalComponent
          modalOpen={modalOpen}
          onRequestClose={() => setModalOpen(false)}
          language={languageSlug}
          amount={+normalPrice}
          currency={currencyCode}
        />
      )}
    </div>
  );
};

export default PayLaterOptionItem;
